export default __webpack_public_path__ + "static/media/claim-submit-error.b83f8cfd.svg";